import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { useResizeDetector } from 'react-resize-detector';
import { Box } from '@mui/material';
import 'console/tabs/tabs.sass';
import { SmallNavigationTabs } from './components/navigation-tabs/small';
const min_px_per_tab = 65;
const popup_button_width = 65;
const Navigation = memo(function Navigation(props) {
    const { handles, width } = props;
    if (width == null) {
        return null;
    }
    const full_tabs = ~~((width - popup_button_width) / min_px_per_tab);
    const plain_tabs = handles.slice(0, full_tabs);
    const more_tabs = handles.slice(full_tabs);
    const more_tabs_selected = more_tabs.some((tab) => tab.selected);
    const px_per_tab = width / handles.length;
    const need_popup = px_per_tab <= min_px_per_tab;
    if (!need_popup) {
        return _jsx(SmallNavigationTabs, { handles: handles, tab_width: px_per_tab });
    }
    const px_per_tab_with_more_button = width / (full_tabs + 1);
    return (_jsx(SmallNavigationTabs, { handles: plain_tabs, more_handles: more_tabs, tabs_count: full_tabs, moreTabsSelected: more_tabs_selected, need_more_button: true, tab_width: px_per_tab_with_more_button }));
});
export const SmallNavigation = memo(function SmallNavigation(props) {
    const { handles } = props;
    const { width, ref } = useResizeDetector({
        handleHeight: false,
        refreshMode: 'throttle',
        refreshRate: 300,
    });
    return (_jsx(Box, { "data-tooltip": "navigation-bar", ref: ref, children: _jsx(Navigation, { handles: handles, width: width }) }));
});
